import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);

import { SimulatorTypeEnum } from '@schemas/scenarios-simulator/types';
import { addWorkdays, startDate } from '@utils/datetime';

const getDefaultProposalValidity = (simulator?: keyof typeof SimulatorTypeEnum) => {
  const currentDate = dayjs();
  const daysDiff = simulator === 'SCENARIOS_SIMULATOR' ? 1 : 15; // TODO -> Review how this rule will be applied for hybrid simulations

  let resultValidity = currentDate.add(daysDiff, 'days');

  if (resultValidity.isoWeekday() === 6) resultValidity = resultValidity.add(2, 'days');
  else if (resultValidity.isoWeekday() === 7) resultValidity = resultValidity.add(1, 'days');

  return resultValidity.format('DD/MM/YYYY');
};

export const compareAndGetProposalValidity = (
  proposalValidity?: string,
  simulator?: keyof typeof SimulatorTypeEnum,
): string => {
  const defaultProposalValidity = getDefaultProposalValidity();
  const currentDate = dayjs();
  const maxValidityDate = addWorkdays(currentDate, 5); // Maximum: Current day + 5 workdays

  if (simulator && simulator === 'SCENARIOS_SIMULATOR') {
    const clarkeDate = addWorkdays(startDate(), 2);
    return clarkeDate.isAfter(currentDate) ? clarkeDate.format('DD/MM/YYYY') : currentDate.format('DD/MM/YYYY');
  }

  if (!proposalValidity) return defaultProposalValidity;

  const proposalValidityDate = dayjs(proposalValidity, 'DD/MM/YYYY');

  // Ensure the date is within range
  if (proposalValidityDate.isBefore(currentDate)) {
    return defaultProposalValidity; // Below current date, return default
  }
  if (proposalValidityDate.isAfter(maxValidityDate)) {
    return maxValidityDate.format('DD/MM/YYYY'); // Beyond max date, return max
  }

  return proposalValidityDate.format('DD/MM/YYYY');
};
